import { isEmpty, isNil } from 'lodash';

export function formatMakeModelToUrlParam(make?: string | null, model?: string | null) {
  if (!isNil(make) && !isEmpty(make)) {
    return !isNil(model) && !isEmpty(model) ? `${make.toLowerCase()}>${model.toLowerCase()}` : make.toLowerCase();
  }

  return undefined;
}
